/* Magic In Home — Wishlist (localStorage based) */
(function () {
  'use strict';

  var KEY = 'mih_wishlist_v1';

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (_) { return []; }
  }

  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (_) {}
    document.dispatchEvent(new CustomEvent('mih:wishlist:change', { detail: { list: list } }));
  }

  function has(handle) { return read().indexOf(handle) !== -1; }

  function toggle(handle) {
    if (!handle) return;
    var list = read();
    var idx = list.indexOf(handle);
    if (idx === -1) list.push(handle);
    else list.splice(idx, 1);
    write(list);
    return list.indexOf(handle) !== -1;
  }

  function clear() { write([]); }

  function refreshButtons() {
    document.querySelectorAll('[data-mih-wishlist]').forEach(function (btn) {
      var handle = btn.getAttribute('data-mih-wishlist');
      if (has(handle)) {
        btn.classList.add('is-saved');
        btn.setAttribute('aria-label', 'Remove from wishlist');
      } else {
        btn.classList.remove('is-saved');
        btn.setAttribute('aria-label', 'Add to wishlist');
      }
    });
  }

  function refreshCounts() {
    var n = read().length;
    document.querySelectorAll('[data-mih-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-empty', n === 0);
    });
  }

  // ───────────────────── Toggle on click ─────────────────────
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mih-wishlist]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-mih-wishlist');
    toggle(handle);
    refreshButtons();
    refreshCounts();
    if (isDrawerOpen()) renderWishlistDrawer();
  });

  // ───────────────────── Header icon opens drawer ─────────────────────
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.header__icon--wishlist, [data-mih-wishlist-open]');
    if (!trigger) return;
    if (!document.getElementById('MihWishlistDrawer')) return;
    e.preventDefault();
    e.stopPropagation();
    openDrawer();
  }, true);

  // ───────────────────── Drawer close ─────────────────────
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-mih-wishlist-close]')) {
      e.preventDefault();
      closeDrawer();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isDrawerOpen()) closeDrawer();
  });

  document.addEventListener('mih:wishlist:change', function () {
    refreshButtons();
    refreshCounts();
  });

  // Initial sync
  document.addEventListener('DOMContentLoaded', function () {
    refreshButtons();
    refreshCounts();
  });

  // ───────────────────── Wishlist page renderer ─────────────────────
  function renderWishlistPage() {
    var grid    = document.querySelector('[data-mih-wishlist-grid]');
    var loading = document.querySelector('[data-mih-wishlist-loading]');
    var empty   = document.querySelector('[data-mih-wishlist-empty]');
    var footer  = document.querySelector('[data-mih-wishlist-footer]');
    if (!grid) return;

    var list = read();

    function show(el)  { if (el) el.hidden = false; }
    function hide(el)  { if (el) el.hidden = true; }

    if (!list.length) {
      hide(loading); hide(grid); hide(footer); show(empty);
      return;
    }

    hide(empty);
    show(loading);
    grid.innerHTML = '';

    var fetches = list.map(function (handle) {
      return fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    });

    Promise.all(fetches).then(function (products) {
      hide(loading);
      var any = false;
      products.forEach(function (p) {
        if (!p) return;
        any = true;
        grid.appendChild(buildCard(p));
      });
      if (any) {
        show(grid);
        show(footer);
      } else {
        show(empty);
      }
      refreshButtons();
    });
  }

  function buildCard(p) {
    var card = document.createElement('article');
    card.className = 'mih-pcard mih-reveal is-visible';
    card.setAttribute('data-product-id', p.id);

    var price    = formatMoney(p.price);
    var compare  = p.compare_at_price && p.compare_at_price > p.price ? formatMoney(p.compare_at_price) : '';
    var pct      = compare ? Math.round((p.compare_at_price - p.price) * 100 / p.compare_at_price) : 0;
    var imgSrc   = getProductImageUrl(p, 600);

    card.innerHTML =
      '<a href="/products/' + p.handle + '" class="mih-pcard__media" aria-label="' + escapeHtml(p.title) + '">' +
        (imgSrc ? '<img src="' + imgSrc + '" alt="' + escapeHtml(p.title) + '" class="mih-pcard__img" loading="lazy">' : '') +
        '<div class="mih-pcard__badges">' +
          (compare ? '<span class="mih-badge mih-badge--sale">-' + pct + '%</span>' : '') +
        '</div>' +
        '<button type="button" class="mih-pcard__wishlist is-saved" aria-label="Remove from wishlist" data-mih-wishlist="' + p.handle + '">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>' +
        '</button>' +
      '</a>' +
      '<div class="mih-pcard__body">' +
        '<h3 class="mih-pcard__title"><a href="/products/' + p.handle + '">' + escapeHtml(p.title) + '</a></h3>' +
        '<div class="mih-pcard__price">' +
          '<span class="mih-pcard__price-current">' + price + '</span>' +
          (compare ? '<span class="mih-pcard__price-was">' + compare + '</span>' : '') +
        '</div>' +
      '</div>';

    return card;
  }

  function formatMoney(cents) {
    var rupees = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return '₹' + rupees.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c]);
    });
  }

  function getProductImageUrl(p, width) {
    var src = p.featured_image || (p.images && p.images[0]) || '';
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    if (width) src += (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
    return src;
  }

  // Clear button (works on both page and drawer)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mih-wishlist-clear]');
    if (!btn) return;
    if (confirm('Clear all items from your wishlist?')) {
      clear();
      renderWishlistPage();
      renderWishlistDrawer();
    }
  });

  document.addEventListener('DOMContentLoaded', renderWishlistPage);

  // ───────────────────── Wishlist drawer (offcanvas) ─────────────────────
  function getDrawer() { return document.getElementById('MihWishlistDrawer'); }
  function isDrawerOpen() {
    var d = getDrawer();
    return !!(d && d.classList.contains('is-open'));
  }

  function openDrawer() {
    var d = getDrawer();
    if (!d) return;
    d.hidden = false;
    requestAnimationFrame(function () { d.classList.add('is-open'); });
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('mih-no-scroll');
    renderWishlistDrawer();
    var panel = d.querySelector('.mih-wd__panel');
    if (panel) panel.focus({ preventScroll: true });
  }

  function closeDrawer() {
    var d = getDrawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('mih-no-scroll');
    setTimeout(function () { if (!d.classList.contains('is-open')) d.hidden = true; }, 280);
  }

  function renderWishlistDrawer() {
    var d = getDrawer();
    if (!d) return;
    var list    = d.querySelector('[data-mih-wd-list]');
    var loading = d.querySelector('[data-mih-wd-loading]');
    var empty   = d.querySelector('[data-mih-wd-empty]');
    var foot    = d.querySelector('[data-mih-wd-foot]');
    if (!list) return;

    function show(el) { if (el) el.hidden = false; }
    function hide(el) { if (el) el.hidden = true; }

    var handles = read();
    if (!handles.length) {
      hide(loading); hide(list); hide(foot); show(empty);
      return;
    }

    hide(empty);
    show(loading);
    list.innerHTML = '';

    var fetches = handles.map(function (handle) {
      return fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    });

    Promise.all(fetches).then(function (products) {
      hide(loading);
      var any = false;
      products.forEach(function (p, i) {
        if (!p) {
          var rec = handles[i];
          if (rec) {
            var li = document.createElement('li');
            li.className = 'mih-wd__item mih-wd__item--missing';
            li.innerHTML =
              '<div class="mih-wd__item-body">' +
                '<p class="mih-wd__item-title">Item no longer available</p>' +
                '<p class="mih-wd__item-sub">' + escapeHtml(rec) + '</p>' +
              '</div>' +
              '<button type="button" class="mih-wd__remove" data-mih-wishlist="' + escapeHtml(rec) + '" aria-label="Remove">' +
                '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
              '</button>';
            list.appendChild(li);
          }
          return;
        }
        any = true;
        list.appendChild(buildDrawerItem(p));
      });
      if (any) {
        show(list);
        show(foot);
      } else if (handles.length) {
        show(list);
        show(foot);
      } else {
        show(empty);
      }
      refreshButtons();
    });
  }

  function buildDrawerItem(p) {
    var li      = document.createElement('li');
    li.className = 'mih-wd__item';
    li.setAttribute('data-product-id', p.id);

    var price   = formatMoney(p.price);
    var compare = p.compare_at_price && p.compare_at_price > p.price ? formatMoney(p.compare_at_price) : '';
    var imgSrc  = getProductImageUrl(p, 240);

    li.innerHTML =
      '<a class="mih-wd__item-media" href="/products/' + escapeHtml(p.handle) + '" aria-label="' + escapeHtml(p.title) + '">' +
        (imgSrc ? '<img src="' + imgSrc + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') +
      '</a>' +
      '<div class="mih-wd__item-body">' +
        '<a class="mih-wd__item-title" href="/products/' + escapeHtml(p.handle) + '">' + escapeHtml(p.title) + '</a>' +
        '<div class="mih-wd__item-price">' +
          '<span class="mih-wd__item-price-now">' + price + '</span>' +
          (compare ? ' <span class="mih-wd__item-price-was">' + compare + '</span>' : '') +
        '</div>' +
      '</div>' +
      '<button type="button" class="mih-wd__remove" data-mih-wishlist="' + escapeHtml(p.handle) + '" aria-label="Remove from wishlist">' +
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
      '</button>';
    return li;
  }

  document.addEventListener('mih:wishlist:change', function () {
    if (isDrawerOpen()) renderWishlistDrawer();
  });

  // ───────────────────── Bridge: legacy <wish-list-icon> → our system ─────────────────────
  // The urbanmart card-product.liquid renders <wish-list-icon data-productID="...">. We
  // attach a delegated click handler that resolves the product handle from the closest
  // product card and toggles in our localStorage; we also surface visual state.
  function bridgeLegacyWishlistIcons() {
    document.querySelectorAll('wish-list-icon').forEach(function (el) {
      if (el.__mihBridged) return;
      var handle = el.getAttribute('data-product-handle') || el.dataset.productHandle || '';
      if (!handle) {
        var card = el.closest('a[href*="/products/"], .card-wrapper, .card');
        if (card) {
          var link = card.matches('a[href*="/products/"]') ? card : card.querySelector('a[href*="/products/"]');
          if (link) {
            var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
            if (m) handle = decodeURIComponent(m[1]);
          }
        }
      }
      if (!handle) return;
      el.setAttribute('data-mih-wishlist', handle);
      el.classList.toggle('is-saved', has(handle));
      el.__mihBridged = true;
    });
  }

  document.addEventListener('DOMContentLoaded', bridgeLegacyWishlistIcons);
  document.addEventListener('mih:wishlist:change', bridgeLegacyWishlistIcons);
  if (window.MutationObserver) {
    var mo = new MutationObserver(function () { bridgeLegacyWishlistIcons(); });
    document.addEventListener('DOMContentLoaded', function () {
      mo.observe(document.body, { childList: true, subtree: true });
    });
  }

  // Public API
  window.MIHWishlist = {
    add:    function (h) { var l = read(); if (l.indexOf(h) === -1) { l.push(h); write(l); } },
    remove: function (h) { var l = read(); var i = l.indexOf(h); if (i !== -1) { l.splice(i, 1); write(l); } },
    toggle: toggle,
    has:    has,
    list:   read,
    clear:  clear,
    openDrawer: openDrawer,
    closeDrawer: closeDrawer
  };
})();
